import { LIVENESS_FAILED } from 'common/constants';
import { SendEventDisbursement, sendException } from 'helpers/analytics';
import { setError } from 'store/actions/auth';
import { ekycVerificationV3 } from 'store/actions/disburse';

export const handleSuccessPassiveLivenessV3 = (
  dispatch,
  getState,
  auth,
  res,
  param
) => {
  const code = res?.data?.data?.code;

  if (!code) {
    dispatch(setError('system'));
    return;
  }

  if (code === 1043) {
    if (!param?.verif) {
      dispatch(
        ekycVerificationV3(auth, {
          selfieData: param?.base64Image,
          action: param?.action
        })
      );
    } else if (param?.action) {
      param.action();
    }
    return;
  }

  handleFailedPassiveLivenessV3(dispatch, getState, 'Liveness Failed');
};

const handleFailedPassiveLivenessV3 = (dispatch, getState, action) => {
  dispatch(setError(LIVENESS_FAILED));
  SendEventDisbursement({
    action,
    isSecondApply: getState().loanApply.isSecondApply
  });
  sendException({ desc: action, fatal: 'true' });
};
